import { useContext } from 'react';
import { SearchLoadingProjectContext, SearchResultsProjectContext } from '@/containers/WorkspaceGlobalSearch/Context';
import { formatPlurality } from '@trinity/chat-components';
import Table from './Search.Table.Projects';
import styles from './style/Tab.module.css';

const max = 50;

export default function SearchTabProjects() {
  const projects = useContext(SearchResultsProjectContext);
  const loading = useContext(SearchLoadingProjectContext);

  const isLoading = loading.untouched && loading.loading;

  const data = projects?.items ?? [];
  const countText = !isLoading
    ? `(${getCountLabel(projects?.total ?? 0, 'Project')})`
    : null;
  const pagination = data.length > 25;

  return (
    <div className={styles.root}>
      <Table
        data={data}
        countText={countText}
        pagination={pagination}
        pageSize={25}
        isLoading={isLoading} />
    </div>
  );
}

function getCountLabel(total: number, label: string) {
  return total > max
    ? `+${max} ${formatPlurality(label, max)}`
    : `${total} ${formatPlurality(label, total)}`;
}

export { SearchTabProjects };